import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getTextAlignOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { createButtonBlock } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/createButtonBlock";
import { defaultData as defaultH1Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H1Block/H1BlockDefaultData";
import { EMAIL_DESKTOP_MAX_WIDTH } from "../../../Design/mediaQuery";
import { getAlignmentOptions } from "../../../Utils/buttonStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HeroBlock4",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Heading",
          baseData: defaultH1Data,
          styles: {
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
            padding: getPaddingOptions({
              defaultValue: {
                paddingTop: "0",
                paddingBottom: "0",
                paddingLeft: "0",
                paddingRight: "0",
              },
            }),
            textAlign: getTextAlignOptions("center"),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
          baseData: defaultPData,
          styles: {
            textAlign: getTextAlignOptions("center"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    imageContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "384px",
                minWidth: "100px",
                minHeight: "100px",
                maxWidth: `${EMAIL_DESKTOP_MAX_WIDTH - 64}px`, // 64px is the margin of the container
                maxHeight: "auto",
              },
            }),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    primaryButton: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Button",
          href: "#",
          buttonType: "primaryButton",
          styles: {
            alignment: getAlignmentOptions("center"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
